import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';

import "./Portfolio.scss";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";

import LightGallery from 'lightgallery/react';
import lgVideo from "lightgallery/plugins/video";
import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-video.css";

import Client from '../Components/Client';
import CallAction2 from '../Components/CallAction2';

import BgVd1 from "./../Images/bg1.gif";
import BgVd2 from "./../Images/bg2.gif";

import bannImg1w from "./../Images/gallery-1-1.webp";
import bannImg1 from "./../Images/gallery-1-1.jpg";
import bannImg2w from "./../Images/gallery-1-2.webp";
import bannImg2 from "./../Images/gallery-1-2.jpg";
import bannImg3w from "./../Images/gallery-1-3.webp";
import bannImg3 from "./../Images/gallery-1-3.jpg";

import bannImg4w from "./../Images/gallery-2-1.webp";
import bannImg4 from "./../Images/gallery-2-1.jpg";
import bannImg5w from "./../Images/gallery-2-2.webp";
import bannImg5 from "./../Images/gallery-2-2.jpg";
import bannImg6w from "./../Images/gallery-2-3.webp";
import bannImg6 from "./../Images/gallery-2-3.jpg";

import gallPhoImg1 from "./../Images/gallery/photography/zyx/1.jpg";
import gallPhoImg2 from "./../Images/gallery/photography/azhagi/2.jpg";
import gallPhoImg3 from "./../Images/gallery/photography/ecct/3.jpg";
import gallPhoImg4 from "./../Images/gallery/photography/ecct/1.jpg";
import gallPhoImg5 from "./../Images/gallery/photography/ecct/12.jpg";
import gallPhoImg6 from "./../Images/gallery/photography/zyx/2.jpg";
import gallPhoImg7 from "./../Images/gallery/photography/zyx/5.jpg";
import gallPhoImg8 from "./../Images/gallery/photography/super-auto-forge/1.jpg";

import gallVidImg1 from "./../Images/gallery/videography/1.mp4";
import gallVidImg1t from "./../Images/gallery/videography/1.jpg";
import gallVidImg2 from "./../Images/gallery/videography/2.mp4";
import gallVidImg2t from "./../Images/gallery/videography/2.jpg";
import gallVidImg3 from "./../Images/gallery/videography/3.mp4";
import gallVidImg3t from "./../Images/gallery/videography/3.jpg";
import gallVidImg4 from "./../Images/gallery/videography/4.mp4";
import gallVidImg4t from "./../Images/gallery/videography/4.jpg";
import gallVidImg5 from "./../Images/gallery/videography/5.mp4";
import gallVidImg5t from "./../Images/gallery/videography/5.jpg";
import gallVidImg6 from "./../Images/gallery/videography/6.mp4";
import gallVidImg6t from "./../Images/gallery/videography/6.jpg";
import gallVidImg7 from "./../Images/gallery/videography/7.mp4";
import gallVidImg7t from "./../Images/gallery/videography/7.jpg";
import gallVidImg8 from "./../Images/gallery/videography/8.mp4";
import gallVidImg8t from "./../Images/gallery/videography/8.jpg";


import gallGraImg1 from "./../Images/gallery/graphic-design/anm/brochure7.jpg";
import gallGraImg2 from "./../Images/gallery/graphic-design/maynee/ads4.jpg";
import gallGraImg3 from "./../Images/gallery/graphic-design/ever-bowl/ads2.jpg";
import gallGraImg4 from "./../Images/gallery/graphic-design/kans-one/brochure1.jpg";
import gallGraImg5 from "./../Images/gallery/graphic-design/lets-play/ads2.jpg";
import gallGraImg6 from "./../Images/gallery/graphic-design/ever-bowl/ads3.jpg";
import gallGraImg7 from "./../Images/gallery/graphic-design/tensile-x/brochure3.jpg";
import gallGraImg8 from "./../Images/gallery/graphic-design/super-auto-forge/ads1.jpg";

import gallWebImg1 from "./../Images/gallery/web/maynee/1.jpg";

const BannList1 = [
    { srset1: bannImg1w, srset2: bannImg1 },
    { srset1: bannImg2w, srset2: bannImg2 },
    { srset1: bannImg3w, srset2: bannImg3 },
];
const BannList2 = [
    { srset1: bannImg4w, srset2: bannImg4 },
    { srset1: bannImg5w, srset2: bannImg5 },
    { srset1: bannImg6w, srset2: bannImg6 },
];
const BannList3 = [
    { srset1: bannImg1w, srset2: bannImg1 },
    { srset1: bannImg2w, srset2: bannImg2 },
    { srset1: bannImg3w, srset2: bannImg3 },
    { srset1: bannImg4w, srset2: bannImg4 },
    { srset1: bannImg5w, srset2: bannImg5 },
    { srset1: bannImg6w, srset2: bannImg6 },
];
const filters = [
    { label: 'Photography', id: 'filter-1' },
    { label: 'Videography', id: 'filter-2' },
    { label: 'Graphic Design', id: 'filter-3' },
    { label: 'Web Development', id: 'filter-4' },
];
const photoAlbum = [
    { src: gallPhoImg1, subHtml: '<h4>Photography</h4>' },
    { src: gallPhoImg2, subHtml: '<h4>Photography</h4>' },
    { src: gallPhoImg3, subHtml: '<h4>Photography</h4>' },
    { src: gallPhoImg4, subHtml: '<h4>Photography</h4>' },
    { src: gallPhoImg5, subHtml: '<h4>Photography</h4>' },
    { src: gallPhoImg6, subHtml: '<h4>Photography</h4>' },
    { src: gallPhoImg7, subHtml: '<h4>Photography</h4>' },
    { src: gallPhoImg8, subHtml: '<h4>Photography</h4>' },
]
const videoAlbum = [
    { poster: gallVidImg1t, subHtml: '<h4>Videography</h4>', video: { source: [{ src: gallVidImg1, type: 'video/mp4' }], attributes: { preload: false, controls: true, autoplay: true } } },
    { poster: gallVidImg2t, subHtml: '<h4>Videography</h4>', video: { source: [{ src: gallVidImg2, type: 'video/mp4' }], attributes: { preload: false, controls: true, autoplay: true } } },
    { poster: gallVidImg3t, subHtml: '<h4>Videography</h4>', video: { source: [{ src: gallVidImg3, type: 'video/mp4' }], attributes: { preload: false, controls: true, autoplay: true } } },
    { poster: gallVidImg4t, subHtml: '<h4>Videography</h4>', video: { source: [{ src: gallVidImg4, type: 'video/mp4' }], attributes: { preload: false, controls: true, autoplay: true } } },
    { poster: gallVidImg5t, subHtml: '<h4>Videography</h4>', video: { source: [{ src: gallVidImg5, type: 'video/mp4' }], attributes: { preload: false, controls: true, autoplay: true } } },
    { poster: gallVidImg6t, subHtml: '<h4>Videography</h4>', video: { source: [{ src: gallVidImg6, type: 'video/mp4' }], attributes: { preload: false, controls: true, autoplay: true } } },
    { poster: gallVidImg7t, subHtml: '<h4>Videography</h4>', video: { source: [{ src: gallVidImg7, type: 'video/mp4' }], attributes: { preload: false, controls: true, autoplay: true } } },
    { poster: gallVidImg8t, subHtml: '<h4>Videography</h4>', video: { source: [{ src: gallVidImg8, type: 'video/mp4' }], attributes: { preload: false, controls: true, autoplay: true } } },
]
const graphicAlbum = [
    { src: gallGraImg1, subHtml: '<h4>Graphic Design</h4>' },
    { src: gallGraImg2, subHtml: '<h4>Graphic Design</h4>' },
    { src: gallGraImg3, subHtml: '<h4>Graphic Design</h4>' },
    { src: gallGraImg4, subHtml: '<h4>Graphic Design</h4>' },
    { src: gallGraImg5, subHtml: '<h4>Graphic Design</h4>' },
    { src: gallGraImg6, subHtml: '<h4>Graphic Design</h4>' },
    { src: gallGraImg7, subHtml: '<h4>Graphic Design</h4>' },
    { src: gallGraImg8, subHtml: '<h4>Graphic Design</h4>' },
]
const webAlbum = [
    { src: gallWebImg1, subHtml: '<h4>Web Development</h4>' },
]

export default function Portfolio() {
    const [width, setWidth] = useState(window.innerWidth);
    useEffect(() => {
        window.addEventListener("resize", function (event) {
            setWidth(window.innerWidth);
        });
    });
    const handleContactClick = () => {
        window.dispatchEvent(new Event("scrollToForm"));
    };
    const settings = {
        vertical: true,
        verticalSwiping: true,
        rtl: true,
        speed: 400,
        autoplay: true,
        autoplaySpeed: 2000,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        swipe: false,
        cssEase: 'cubic-bezier(0.68, -0.55, 0.27, 1.55)',
    };
    const settings2 = {
        vertical: true,
        verticalSwiping: true,
        speed: 400,
        autoplay: true,
        autoplaySpeed: 2000,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        swipe: false,
        cssEase: 'cubic-bezier(0.68, -0.55, 0.27, 1.55)',
    };
    const settings3 = {
        infinite: true,
        speed: 500,
        autoplay: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    centerPadding: '40px',
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    centerPadding: '30px',
                },
            },
        ],
    };

    const [activeFilter, setActiveFilter] = useState("filter-1");
    const photoGalleryRef = useRef();
    const videoGalleryRef = useRef(null);
    const graphicGalleryRef = useRef(null);
    const webGalleryRef = useRef(null);
    const openGallery = (ref, index) => {
        if (ref.current) {
            ref.current.openGallery(index);
        }
    };

    return (
        <>
            <div className='banner2 banner-portfolio'>
                <div className='video-bg1'><img src={BgVd1} alt='' /></div>
                <div className='container-fluid'>
                    <div className='row'>
                        <div className='col-lg-9 col-18 banner2-lt-ct mb-lg-0'>
                            <table width="100%" cellPadding="0" cellSpacing="0" border="0">
                                <tbody>
                                    <tr>
                                        <td>
                                            <h1 className='fw-300 txt-lg-lt txt-center mb-8' data-aos="fade-down" data-aos-once='true'>Launch Bold. Build Loud. Create Impact</h1>
                                            <p className='f-18 mb-2 txt-lg-lt txt-center line-ht-24' data-aos="fade-up" data-aos-once='true' data-aos-delay="400">At ZYX, we're the plug that turns raw ideas into bold realities.</p>
                                            <p className='f-18 mb-8 txt-lg-lt txt-center line-ht-24' data-aos="fade-up" data-aos-once='true' data-aos-delay="400">We team up with creators, visionaries, and changemakers to spark powerful ideas, design standout strategies, and build brands that thrive. Every step is about energy, synergy, and momentum. Let's co-create, elevate, and make moves that matter, because at ZYX, growth isn't just a goal, it's a vibe.</p>
                                            <div className='txt-lg-lt txt-center' data-aos="fade-up" data-aos-once='true' data-aos-delay="400"><Link className="glow-btn" onClick={handleContactClick}><span>Contact Us</span></Link></div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        {width >= 930 && (<div className='col-lg-9 col-18 banner2-rt-ct mb-0' data-aos="fade-left" data-aos-once='true' data-aos-delay="600">
                            <div className='banner2-slider1'>
                                <Slider className='bann2-slider1' {...settings}>
                                    {BannList1.map((item, index) => {
                                        return (
                                            <div key={index}>
                                                <picture>
                                                    <source srcSet={item.srset1} type="image/webp" />
                                                    <source srcSet={item.srset2} type="image/jpeg" />
                                                    <img src={item.srset2} alt="ZYX Media" title="ZYX Media" width="978" height="1224" />
                                                </picture>
                                            </div>
                                        )
                                    })}
                                </Slider>
                            </div>
                            <div className='banner2-slider2'>
                                <Slider className='bann2-slider2' {...settings2}>
                                    {BannList2.map((item, index) => {
                                        return (
                                            <div key={index}>
                                                <picture>
                                                    <source srcSet={item.srset1} type="image/webp" />
                                                    <source srcSet={item.srset2} type="image/jpeg" />
                                                    <img src={item.srset2} alt="ZYX Media" title="ZYX Media" width="978" height="1224" />
                                                </picture>
                                            </div>
                                        )
                                    })}
                                </Slider>
                            </div>
                        </div>)}
                        {width <= 930 && (<div className='col-lg-9 col-18 banner2-rt-ct mb-0' data-aos="fade-left" data-aos-once='true' data-aos-delay="600">
                            <div className='banner2-slider3'>
                                <Slider className='bann2-slider3' {...settings3}>
                                    {BannList3.map((item, index) => {
                                        return (
                                            <div key={index}>
                                                <picture>
                                                    <source srcSet={item.srset1} type="image/webp" />
                                                    <source srcSet={item.srset2} type="image/jpeg" />
                                                    <img src={item.srset2} alt="ZYX Media" title="ZYX Media" width="978" height="1224" />
                                                </picture>
                                            </div>
                                        )
                                    })}
                                </Slider>
                            </div>
                        </div>)}
                    </div>
                </div>
                <div className='video-bg2'><img src={BgVd2} alt='' /></div>
            </div>
            <div className='filter-gallery bg-pattern'>
                <div className='container-fluid sectin' style={{ paddingTop: '80px' }}>
                    <div className='tab-head txt-center mb-8' data-aos="fade-up" data-aos-once='true'>
                        <ul>
                            {filters.map((filter, index) => {
                                return (
                                    <li key={index} data-head={filter.id} className={activeFilter === filter.id ? 'active' : ''} onClick={() => setActiveFilter(filter.id)}>
                                        {filter.label}
                                    </li>
                                )
                            })}
                        </ul>
                    </div>
                    <div className='fg-cont'>
                        {activeFilter === "filter-1" && (
                            <>
                                <LightGallery download={false} onInit={(detail) => (photoGalleryRef.current = detail.instance)} speed={500} dynamic dynamicEl={photoAlbum} ref={photoGalleryRef} elementClassNames="d-none" />
                                <ul className="row g-0">
                                    {photoAlbum.slice(0, 8).map((img, index) => (
                                        <li key={index} className="col-xl-3 col-sm-5 col-9 mb-0" data-aos="fade-up" data-aos-once="true">
                                            <div>
                                                <img src={img.src} alt="Photography" onClick={() => openGallery(photoGalleryRef, index)} />
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </>
                        )}
                        {activeFilter === "filter-2" && (
                            <>
                                <LightGallery download={false} onInit={(detail) => (videoGalleryRef.current = detail.instance)} speed={500} dynamic dynamicEl={videoAlbum} ref={videoGalleryRef} plugins={[lgVideo]} elementClassNames="d-none" />
                                <ul className="row g-0">
                                    {videoAlbum.slice(0, 8).map((img, index) => (
                                        <li key={index} className="col-xl-3 col-sm-5 col-9 mb-0" data-aos="fade-up" data-aos-once="true">
                                            <div className='video-icon'>
                                                <img src={img.poster} alt="Videography" onClick={() => openGallery(videoGalleryRef, index)} />
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </>
                        )}
                        {activeFilter === "filter-3" && (
                            <>
                                <LightGallery download={false} onInit={(detail) => (graphicGalleryRef.current = detail.instance)} speed={500} dynamic dynamicEl={graphicAlbum} ref={graphicGalleryRef} elementClassNames="d-none" />
                                <ul className="row g-0">
                                    {graphicAlbum.slice(0, 8).map((img, index) => (
                                        <li key={index} className="col-xl-3 col-sm-5 col-9 mb-0" data-aos="fade-up" data-aos-once="true">
                                            <div>
                                                <img src={img.src} alt="Graphic Design" onClick={() => openGallery(graphicGalleryRef, index)} />
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </>
                        )}
                        {activeFilter === "filter-4" && (
                            <>
                                <LightGallery download={false} onInit={(detail) => (webGalleryRef.current = detail.instance)} speed={500} dynamic dynamicEl={webAlbum} ref={webGalleryRef} elementClassNames="d-none" />
                                <ul className="row g-0">
                                    {webAlbum.slice(0, 8).map((img, index) => (
                                        <li key={index} className="col-xl-3 col-sm-5 col-9 mb-0" data-aos="fade-up" data-aos-once="true">
                                            <div>
                                                <img src={img.src} alt="Web Development" onClick={() => openGallery(webGalleryRef, index)} />
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </>
                        )}
                    </div>
                </div>
            </div>
            <Client />
            <CallAction2 />
        </>
    )
}
